import { useMemo } from "react";
import { BaseSignedOrder, OrderType } from "@/api/orders/types";
import useSettleSignedSale from "@/web3/contracts/Exchange/actions/useSettleSignedSale";
import useSettleDutchAuction from "@/web3/contracts/Exchange/actions/useSettleDutchAuction";

export default function usePurchaseSettleMutation(auction: BaseSignedOrder) {
  const useSettleMutation = useMemo(() => {
    switch (auction.type) {
      case OrderType.FIXED_AUCTION:
        return useSettleSignedSale;
      case OrderType.PRIVATE_AUCTION:
        return useSettleSignedSale;
      case OrderType.DUTCH_AUCTION:
        return useSettleDutchAuction;
      //   case OrderType.RESERVE_AUCTION:
      //     return useSettleReserveAuction;
      default:
        throw Error("Invalid auction type!");
    }
  }, [auction.type]);

  return useSettleMutation(auction as any);
}
